// export const getCommonParams = (customStylesUri) => ({
//   mainFrameUrl: `${window.location.origin}/turbo-sports`,
//   host: "https://syscorp-fv4r5l83.sbifm.online",
//   cid: "syscorp",
//   lang: "en",
//   customStyles: customStylesUri,
// });
 
export const getCommonParams = (customStylesUri) => ({
  mainFrameUrl: `${window.location.origin}/turbo-sports`,
  host: "https://stage.sportbook.work",
  cid: "syscorp-stage",
  lang: "en",
  customStyles: customStylesUri,
});

